module.exports = __webpack_public_path__ + "static/media/transporter-empty.bfad2a62.svg";